module.exports = __webpack_public_path__ + "img/lyqc.4c19d60a.png";